import Html5Logo from '../../assets/skills-logo/Html5.png';
import Css3Logo from '../../assets/skills-logo/CSS3.png';
import BootstrapLogo from '../../assets/skills-logo/Bootstrap.png';
import TailwindLogo from '../../assets/skills-logo/Tailwind-CSS.png';
import SassLogo from '../../assets/skills-logo/SASS.png';
import JSLogo from '../../assets/skills-logo/JS.png';
import JQueryLogo from '../../assets/skills-logo/Jquery.png';
import ReactLogo from '../../assets/skills-logo/React.png';
import NextLogo from '../../assets/skills-logo/Next.png';
import ShopifyLogo  from '../../assets/skills-logo/Shopify.png';
import MsblazorLogo from '../../assets/skills-logo/Ms-Blazor.png';
import RadzenLogo from '../../assets/skills-logo/Radzen.png';
import GitCommandLogo from '../../assets/skills-logo/Git-command.png';
import GitHubLogo from '../../assets/skills-logo/GitHub.png';
import JiraLogo from '../../assets/skills-logo/Jira.png';
import ClickupLogo from '../../assets/skills-logo/Clickup.png';
import GSAPLogo from '../../assets/skills-logo/Greensock-GSAP.png';
import FigmaLogo from '../../assets/skills-logo/Figma.png';

const skillsData =  {
    "Skills": [
        {
            "category": "UIDevSkills",
            "category-title": "UI Developer Skills",
            "skills": [
                {
                    "logo": Html5Logo,
                    "title": "HTML5"
                },
                {
                    "logo": Css3Logo,
                    "title": "CSS3"
                },
                {
                    "logo": BootstrapLogo,
                    "title": "Bootstrap 5.3"
                },
                {
                    "logo": TailwindLogo,
                    "title": "Tailwind CSS"
                },
                {
                    "logo": SassLogo,
                    "title": "SCSS(SASS)"
                }
            ]
        },
        {
            "category": "DynamicFrameworksSkills",
            "category-title": "Frontend Development Skills",
            "skills": [
                {
                    "logo": JSLogo,
                    "title": "JavaScript"
                },
                {
                    "logo": JQueryLogo,
                    "title": "jQuery"
                },
                {
                    "logo": ReactLogo,
                    "title": "React"
                },
                {
                    "logo": NextLogo,
                    "title": "Next JS"
                },
                {
                    "logo": ShopifyLogo,
                    "title": "Shopify"
                },
                {
                    "logo": MsblazorLogo,
                    "title": "Microsoft Blazor (C#)"
                },
                {
                    "logo": RadzenLogo,
                    "title": "Radzen Blazor"
                }
            ]
        },
        {
            "category": "ToolsSkills",
            "category-title": "Extra Skills",
            "skills": [
                {
                    "logo": GitCommandLogo,
                    "title": "Git Command Tool"
                },
                {
                    "logo": GitHubLogo,
                    "title": "GitHub"
                },
                {
                    "logo": JiraLogo,
                    "title": "Jira"
                },
                {
                    "logo": ClickupLogo,
                    "title": "ClickUp"
                },
                {
                    "logo": GSAPLogo,
                    "title": "GSAP"
                },
                {
                    "logo": FigmaLogo,
                    "title": "Figma"
                }
            ]
        }
    ]
}

export default skillsData;